// extracted by mini-css-extract-plugin
module.exports = {"userCard":"UserCard_userCard__1zp5b","gradient":"UserCard_gradient__3jnHU"};